module.exports = __webpack_public_path__ + "img/loud-speaker.180f5e83.svg";